import { ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ContentService } from '../../spartacus/services/content.service';
import { UserInfoService } from '../../spartacus/services/user-info.service';
import { BaseSiteService } from '@spartacus/core';


@Component({
    selector: 'app-open-credit-invoice-dashboard',
    templateUrl: './open-credit-invoice-dashboard.component.html',
    styleUrls: ['./open-credit-invoice-dashboard.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class OpenCreditInvoiceDashboardComponent {
  currentSite: string = "";
  rbavalue: any;
  showloader: boolean = false;

  constructor(public contentService: ContentService, public userInfoService: UserInfoService, private baseSiteService: BaseSiteService, private cdr: ChangeDetectorRef) { }
  // invoiceNode: Observable<any> = this.userInfoService.getInvoiceData();
  invoiceNode: any;
delay = (ms: number) => new Promise(res => setTimeout(res, ms));

async myTask() {
  this.showloader = true;
  
  // Wait for 3000ms (3 seconds)
  await this.delay(2000);
  
 this.showloader = false;
  this.cdr.detectChanges();
}
  ngOnInit() {
    this.myTask();
  
    this.baseSiteService.getActive().subscribe(site => {
      this.currentSite = site;
    })
    this.userInfoService.getInvoiceData().subscribe(value => {
      this.invoiceNode = value
      this.userInfoService.setdashboardinvoiceCount(this.invoiceNode?.invoiceCount)
      this.cdr.detectChanges();
    })

    if (this.currentSite == 'seqirusb2b-uk') {
      this.rbavalue = localStorage.getItem('rbapermission');
      this.rbavalue = JSON.parse(this.rbavalue);
      this.cdr.detectChanges();

      this.userInfoService.getswitchrba().subscribe(value => {
        if (value) {
          this.rbavalue = value;
          this.cdr.detectChanges();
        }
      });
    }
  }
   ngAfterViewInit() {

    this.userInfoService.getrbaheader().subscribe(value => {
      if (value) {
        // this.rbavarible=localStorage.getItem('rbapermission');
        this.rbavalue = value;
        this.cdr.detectChanges();
      }
    });

  }
  ngOnDestroy(){
    this.rbavalue="";
  }
  
}
